export const multiCurrencyVisualTemplate = `
<div>
  <div class="font-weight-normal text-capitalize ml-1">
  {{currencyItem.currency}}
  </div>

  {{#each balance as | balanceObj |}}

    {{#if (eq balanceObj.currency ../currencyItem.currency)}}

    <div class="ml-1">  {{balanceObj.amount}} </div>

    {{/if}}

  {{/each}}

</div>
`;

export const multiCurrencyDropdownTemplate = `
<div>
  <div class="font-weight-normal text-capitalize">{{currencyItem.currency}}</div>

  {{#each balance as | balanceObj |}}

    {{#if (eq balanceObj.currency ../currencyItem.currency)}}

      <div>  {{balanceObj.amount}} </div>

    {{/if}}

  {{/each}}

</div>
`;
